import {
  Boxes,
  BriefcaseBusiness,
  ClipboardList,
  ClipboardPlus,
  Factory,
  Handshake,
  LogOut,
  Package,
  Star,
  Trash2,
  TrendingUp,
  Tv,
  UserPlus,
  Users,
  Wallet,
} from "lucide-react";

export const navSections = [
  {
    id: "catalog",
    title: "Catalog",
    links: [
      { name: "Deals", link: "/deals", icon: Handshake },
      { name: "Trash", link: "/deals/trash", icon: Trash2 },
      { name: "Categories", link: "/categories", icon: Boxes },
      { name: "Promo submissions", link: "/promo-submissions", icon: ClipboardList },
    ],
  },
  {
    id: "sales",
    title: "Sales",
    links: [
      { name: "Orders", link: "/orders", icon: Package },
      { name: "Reviews", link: "/reviews", icon: Star },
      { name: "Payments", link: "/payments", icon: Wallet },
    ],
  },
  {
    id: "brands",
    title: "Brands",
    links: [
      { name: "Enrolled brands", link: "/brands", icon: Factory },
      { name: "Add a brand", link: "/create-brand", icon: ClipboardPlus },
    ],
  },
  {
    id: "audience",
    title: "Audience",
    links: [{ name: "Subscribers", link: "/subscribers", icon: Users }],
  },
  {
    id: "affiliates",
    title: "Affiliates",
    links: [
      { name: "Affiliates", link: "/promoters", icon: UserPlus },
      { name: "Publisher leads", link: "/potential-publishers", icon: Tv },
      { name: "Merchant leads", link: "/potential-merchants", icon: BriefcaseBusiness },
      { name: "Conversions", link: "/publisher-conversion-analytics", icon: TrendingUp },
    ],
  },
];

export const logoutLink = { name: "Log out", link: "/logout", icon: LogOut };
